@if (data$ | async; as data) {
  <app-alerts />

  <app-warehouse-receipt-form
    [data]="data"
    [fileUploadVisibility]="fileUploadVisibility()"
    (submitSuccessEvent)="handleSubmitSuccessEvent($event)" />
} @else {
  <app-spinner-filled />
}
